var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#F5F5F5;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#CBCBCB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.1,5.8c0.1,0.8,0.2,1.6,0.4,2.3L6.5,9.1C6.1,8.1,5.9,7,5.8,5.8H7.1 M15.9,16.5c0.8,0.2,1.5,0.3,2.3,0.4v1.3 c-1.2-0.1-2.3-0.3-3.4-0.7L15.9,16.5 M8,4H4.9C4.4,4,4,4.4,4,4.9C4,13.2,10.8,20,19.1,20c0.5,0,0.9-0.4,0.9-0.9V16 c0-0.5-0.4-0.9-0.9-0.9c-1.1,0-2.2-0.2-3.2-0.5c-0.1,0-0.2,0-0.3,0c-0.2,0-0.5,0.1-0.6,0.3l-2,2c-2.5-1.3-4.6-3.3-5.9-5.9l2-2 c0.2-0.2,0.3-0.6,0.2-0.9C9.1,7.1,8.9,6,8.9,4.9C8.9,4.4,8.5,4,8,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPhone);
export default __webpack_public_path__ + "static/media/icn_phone.78b4047f51ce9b52783e1d00f83134c7.svg";
export { ForwardRef as ReactComponent };